import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=12f93469&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=ts&"
export * from "./chat.vue?vue&type=script&lang=ts&"
import style0 from "./chat.vue?vue&type=style&index=0&id=12f93469&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f93469",
  null
  
)

export default component.exports